module.exports = __webpack_public_path__ + "img/ch09_12_转圈拍照.40350fbc.jpg";